import { useEffect, useState } from "react";
import { types } from "../constants/constants";

export const useServices = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetch(`${types.API_URL}services`)
      .then((res) => res.json())
      .then((data) => setServices(data.services || []))
      .catch(() => setServices([]));
  }, []);

  return services;
};
